export const getEyefinityService = (services = []) => (
  services.find(service => service?.config?.service === 'eyefinity')
)

export const getEyefinityProviderOptions = (services = []) => {
  const providers = getEyefinityService(services)?.config?.providers || []

  return providers
    .filter(Boolean)
    .map(provider => ({ label: provider, value: provider }))
}
